module.exports = __webpack_public_path__ + "static/media/billiestories.6a7aefc7.jpg";